import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

/**
 * ProgrammeCarousel
 * @param {{ images: string[] }} props
 * @returns JSX.Element
 */
export default function ProgrammeCarousel({ images = [] }) {
  return (
    <div className="programme-carousel-container">
      <Swiper
        modules={[Navigation]}
        slidesPerView={1}
        navigation={true}
        loop={true}
        className="programme-carousel"
      >
        {images.map((src, idx) => (
          <SwiperSlide key={idx} className="programme-carousel-slide">
            <img
              src={src}
              alt={`Slide ${idx + 1}`}
              className="programme-carousel-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
